<template>
  <div class="modules-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="modules-container">
      <!-- Header Section -->
      <div class="modules-header">
        <div class="header-content">
          <h1 class="page-title">
            <i class="fas fa-cubes title-icon"></i>
            Módulos do Sistema
          </h1>
          <p class="page-subtitle">Visualize os módulos disponíveis</p>
        </div>
      </div>

      <!-- Content Section -->
      <div class="modules-content">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <!-- No Results State -->
          <div v-show="modules.length == 0 && !loading" class="no-results">
            <i class="fas fa-cube no-results-icon"></i>
            <h4 class="no-results-title">Nenhum módulo encontrado</h4>
            <p class="no-results-text">Não há módulos disponíveis no momento</p>
          </div>

          <!-- Modules Grid -->
          <div v-show="modules.length > 0" class="modules-grid">
            <div v-for="module in modules" :key="module.id" class="module-card">
              <img v-if="logo" :src="logo" alt="Sistema Clin" class="logo" />
              <div class="module-content">
                <h3 class="module-title">{{ module.description }}</h3>
                <p class="module-subtitle">Módulo do Sistema</p>
              </div>
              <div class="module-whatsapp" @click.stop="openWhatsApp(module)">
                <div class="whatsapp-icon">
                  <i class="fas fa-comment"></i>
                </div>
                <span class="whatsapp-text"
                  >Enviar mensagem para o SISTEMA CLIN</span
                >
              </div>
            </div>
          </div>

          <!-- Module Stats -->
          <div v-show="modules.length > 0" class="modules-stats">
            <div class="stats-card">
              <div class="stat-item">
                <div class="stat-icon">
                  <i class="fas fa-layer-group"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-value">{{ modules.length }}</div>
                  <div class="stat-label">
                    {{ modules.length === 1 ? "Módulo" : "Módulos" }}
                    Disponíveis
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import api from "../services/api";
import { userData } from "../lib/functions";

export default {
  name: "Modules",
  components: {
    NavBar,
    AuthBySessionExpired,
  },
  data() {
    return {
      logo: null,
      modules: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        let { logo } = userData();
        this.logo = logo;
        this.loading = true;
        const response = await api.get("/modules");
        const { modules } = response.data;
        this.modules = modules;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    openWhatsApp(module) {
      const message = `Olá, quero saber mais sobre o módulo ${module.description}`;
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/5511960671262?text=${encodedMessage}`;
      window.open(whatsappUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.modules-modern {
  min-height: 100vh;
  background: linear-gradient(
    135deg,
    #f8fafc 0%,
    #e2e8f0 25%,
    #cbd5e1 50%,
    #e2e8f0 75%,
    #f1f5f9 100%
  );
}

.modules-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.modules-header {
  padding: 24px 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 50%,
    rgba(241, 245, 249, 0.95) 100%
  );
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.header-content {
  text-align: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(
    135deg,
    #1e293b 0%,
    #374151 35%,
    #0f65b0 70%,
    #1e40af 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.page-subtitle {
  color: #64748b;
  margin: 8px 0 0 0;
  font-size: 16px;
}

/* Content Section */
.modules-content {
  margin-bottom: 32px;
}

.loading-overlay {
  border-radius: 16px;
  min-height: 400px;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 80px 24px;
  color: #6b7280;
}

.no-results-icon {
  font-size: 64px;
  color: #d1d5db;
  margin-bottom: 24px;
}

.no-results-title {
  color: #1e293b;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.no-results-text {
  color: #6b7280;
  font-size: 16px;
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

/* Modules Grid */
.modules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.module-card {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(248, 250, 252, 0.8) 50%,
    rgba(241, 245, 249, 0.9) 100%
  );
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  overflow: hidden;
}

.module-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #0f65b0 0%, #1e40af 50%, #3b82f6 100%);
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 0.3s ease;
}

.module-card:hover {
  transform: translateY(-4px);
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(248, 250, 252, 0.95) 50%,
    rgba(239, 246, 255, 0.9) 100%
  );
  box-shadow: 0 12px 35px rgba(15, 101, 176, 0.2);
  border-color: rgba(15, 101, 176, 0.3);
}

.module-card:hover::before {
  transform: scaleY(1);
}

.logo {
  width: 100px;
  object-fit: contain !important;
}

/* Module Header */
.module-content {
  flex: 1;
}

.module-title {
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #1e293b 0%, #374151 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.module-subtitle {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  margin: 0;
  padding: 4px 12px;
  background: linear-gradient(
    135deg,
    rgba(241, 245, 249, 0.8) 0%,
    rgba(226, 232, 240, 0.6) 100%
  );
  border-radius: 20px;
  display: inline-block;
  border: 1px solid rgba(203, 213, 225, 0.3);
}

/* WhatsApp Section */
.module-whatsapp {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(
    135deg,
    rgba(37, 211, 102, 0.1) 0%,
    rgba(37, 211, 102, 0.05) 50%,
    rgba(248, 250, 252, 0.8) 100%
  );
  border: 2px solid rgba(37, 211, 102, 0.2);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.module-whatsapp::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(37, 211, 102, 0.1) 50%,
    transparent 100%
  );
  transition: left 0.5s ease;
}

.module-whatsapp:hover::before {
  left: 100%;
}

.module-whatsapp:hover {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 35%, #075e54 100%);
  border-color: #25d366;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
}

.whatsapp-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
}

.module-whatsapp:hover .whatsapp-icon {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(255, 255, 255, 0.3);
}

.whatsapp-text {
  font-size: 13px;
  font-weight: 600;
  color: #25d366;
  flex: 1;
  text-align: left;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: color 0.3s ease;
}

.module-whatsapp:hover .whatsapp-text {
  color: white;
}

/* Module Stats */
.modules-stats {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.stats-card {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.9) 50%,
    rgba(239, 246, 255, 0.95) 100%
  );
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.4);
  max-width: 300px;
  width: 100%;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: center;
}

.stat-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(
    135deg,
    #10b981 0%,
    #059669 35%,
    #047857 70%,
    #065f46 100%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}

.stat-content {
  text-align: left;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.stat-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modules-container {
    padding: 0 16px;
  }

  .modules-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .modules-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .module-card {
    padding: 20px;
    gap: 16px;
  }

  .module-title {
    font-size: 16px;
  }

  .whatsapp-text {
    font-size: 12px;
  }

  .no-results {
    padding: 60px 16px;
  }

  .no-results-icon {
    font-size: 48px;
  }

  .no-results-title {
    font-size: 20px;
  }

  .stats-card {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .modules-grid {
    grid-template-columns: 1fr;
  }

  .module-card {
    padding: 16px;
    gap: 12px;
  }

  .module-whatsapp {
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    text-align: center;
  }

  .whatsapp-text {
    font-size: 11px;
    text-align: center;
  }

  .stat-item {
    flex-direction: column;
    gap: 12px;
  }

  .stat-content {
    text-align: center;
  }

  .stat-icon {
    width: 45px;
    height: 45px;
    font-size: 18px;
  }
}

/* Animation for grid items */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.module-card {
  animation: slideInUp 0.3s ease forwards;
}

.module-card:nth-child(1) {
  animation-delay: 0.1s;
}
.module-card:nth-child(2) {
  animation-delay: 0.2s;
}
.module-card:nth-child(3) {
  animation-delay: 0.3s;
}
.module-card:nth-child(4) {
  animation-delay: 0.4s;
}
.module-card:nth-child(5) {
  animation-delay: 0.5s;
}
.module-card:nth-child(6) {
  animation-delay: 0.6s;
}
</style>